export const AUDIO_OPTIONS = [
  { value: 'no_save', label: 'Live transcription without playback [3 credits]' },
  { value: 'transcribe_now', label: 'Live transcription with playback [3 credits]' },
  { value: 'save_only', label: 'Record session [1 credit]' },
];
